import { useRef, useState } from "react";
import { Logo } from "@/components/Logo";

const ACCENT = "#9E1B22";

// Hero logo with cursor-reactive 3D tilt + dynamic brand glow (parallax neumorphic frame).
export const InteractiveLogo = () => {
  const ref = useRef(null);
  const [tilt, setTilt] = useState({ rx: 0, ry: 0 });
  const [hover, setHover] = useState(false);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    setTilt({ rx: +(py * -10).toFixed(2), ry: +(px * 12).toFixed(2) });
  };
  const reset = () => { setTilt({ rx: 0, ry: 0 }); setHover(false); };

  return (
    <div
      ref={ref}
      data-testid="hero-logo"
      onMouseMove={onMove}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={reset}
      className="relative flex items-center justify-center lg:justify-end"
      style={{ perspective: "900px" }}
    >
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full blur-3xl"
        style={{ backgroundColor: ACCENT, opacity: hover ? 0.3 : 0.12, transform: `translate(-50%,-50%) scale(${hover ? 1.18 : 1})`, transition: "all 0.4s cubic-bezier(0.22,1,0.36,1)" }}
      />
      <div
        className="pointer-events-none absolute right-2 top-4 -z-10 h-48 w-48 rounded-full blur-3xl"
        style={{ backgroundColor: "#ffffff", opacity: hover ? 0.95 : 0.45, transition: "all 0.4s cubic-bezier(0.22,1,0.36,1)" }}
      />
      <div
        className="relative"
        style={{
          transform: `rotateX(${tilt.rx}deg) rotateY(${tilt.ry}deg) translateY(${hover ? -8 : 0}px)`,
          transformStyle: "preserve-3d",
          transition: "transform 0.4s cubic-bezier(0.22,1,0.36,1)",
        }}
      >
        <div
          style={{
            transform: "translateZ(40px)",
            filter: hover
              ? "drop-shadow(0 0 42px rgba(158,27,34,0.5)) drop-shadow(0 22px 44px rgba(255,255,255,0.25))"
              : "drop-shadow(0 18px 38px rgba(23,23,23,0.18))",
            transition: "filter 0.4s cubic-bezier(0.22,1,0.36,1)",
          }}
        >
          <Logo imgClassName="w-full max-w-[22rem] object-contain" />
        </div>
      </div>
    </div>
  );
};
